import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { SidePanelCard } from '../../models/side-panel-card';
import { SIDE_PANEL_FONTS_URL } from './side-panel-config';
import { renderCards } from './sp-renderer';

/**
 * Paints course side panel cards (at most two, in order) in the CLASSIC or PRISM design language.
 * Used by the course page panel and by /side-panel-preview, so the admin preview is exactly what students see.
 */
@Component({
  selector: 'app-side-panel-cards',
  template: '<div #rail class="sp-rail"></div>',
  styleUrls: ['./side-panel-cards.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class SidePanelCardsComponent implements OnInit, OnChanges {

  @Input() cards: SidePanelCard[] = [];

  /** Emits the number of cards drawn after every render. */
  @Output() rendered = new EventEmitter<number>();

  @ViewChild('rail', { static: true }) rail: ElementRef<HTMLDivElement>;

  ngOnInit(): void {
    loadFonts();
    this.render();
  }

  ngOnChanges(): void {
    this.render();
  }

  private render(): void {
    if (!this.rail) {
      return;
    }
    this.rendered.emit(renderCards(this.rail.nativeElement, this.cards));
  }
}

// Fonts must be declared on the document: @font-face inside a shadow root is ignored by some browsers.
function loadFonts(): void {
  if (document.getElementById('sp-fonts')) {
    return;
  }
  const link = document.createElement('link');
  link.id = 'sp-fonts';
  link.rel = 'stylesheet';
  link.href = SIDE_PANEL_FONTS_URL;
  document.head.appendChild(link);
}
